import { createContext, useState,useEffect , useContext} from "react";
import { firebaseFire } from './../../services/Firebase'
import { getDoc,getDocs,  query, where,doc,collection, limit,orderBy} from 'firebase/firestore'
import {UserContext} from '../../UserContext';
import  secureLocalStorage  from  "react-secure-storage";
export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {

    const [activeMenu, setActiveMenu] = useState('');
    const {userLogin} = useContext(UserContext);
    const [user, setUser] = useState();

    useEffect( () => {
        const data = secureLocalStorage.getItem("user");
        if( data ){
            setUser(JSON.parse(data));
        }
    },[]);

    const findMaintenance = (filter) => {
        let dinamicFilter = [];

        if(typeof filter.from_date != 'undefined'  && filter.from_date !== ''){
            dinamicFilter.push( where("date",">=",Date.parse(filter.from_date)) );
        }

        if(typeof filter.to_date != 'undefined'  &&  filter.to_date !== ''){
            dinamicFilter.push( where("date","<=",Date.parse(filter.to_date)) );
        }

        if(typeof filter.service != 'undefined'  &&  filter.service != ''){
            dinamicFilter.push(where("service","==",filter.service));
        }

        if(dinamicFilter.length == 0){
            dinamicFilter.push(limit(20));
        }

        const q = query(collection(firebaseFire, "mantenciones"),
                        where("user.partner.id", "==", user.partner.id ),orderBy("date", "desc") );
        return getDocs(q);
    }



    const getMaintenance =  () => {
        const q = query(collection(firebaseFire, "mantenciones"),
                        where("user.partner.id", "==", userLogin.partner.id ));
        return getDocs(q);
    }


    const ContextProviderValues = {
        findMaintenance,
        getMaintenance,
        activeMenu,
        setActiveMenu,


    };

    return (
        <AdminContext.Provider value={ContextProviderValues}>
            {children}
        </AdminContext.Provider>
    )
}
